<template>
	<guest-template
		navHeaderTitle="Back"
		:showNavHeader="true"
		:showNavFooter="false"
	>
		<v-container class="categories-view">
			<SearchCategories
				:max="null"
				defaultShow="true"
				@click="onCategoryClick"
				breakpoint="xs"
			/>
		</v-container>
	</guest-template>
</template>

<script>
import guestTemplate from '../../templates/guestTemplate.vue'
export default {
	components: { guestTemplate },
	name: 'CategoriesView',

	data: () => ({}),
	methods: {
		onCategoryClick(cat) {
			this.$router.push({
				name: 'results',
				params: { category: cat.title }
			})
		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../styles/typography-screen';

.categories-view {
	background-color: $white;
	padding-top: 42px;
}

.categories-view::v-deep .category-list-title {
	font-weight: 600;
}

.categories-view::v-deep .category-list {
	padding-top: 0 !important;
}
</style>
